import { render } from "./App.vue?vue&type=template&id=163d9981&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=163d9981&lang=css"
import "./App.vue?vue&type=style&index=1&id=163d9981&scoped=true&lang=css"

import exportComponent from "D:\\Code\\mt\\Agent\\ui\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-163d9981"]])

export default __exports__